import React from 'react'
import PriorityAct from './priority'
import TaskStatusAct from './taskStatus'
import UnitAct from './Unit'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'

function PlanningActivityIndex() {
    return(
        <>
        <TextMediumSM content="Planning" />
        <TextMediumSM content="Activity" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <PriorityAct/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <TaskStatusAct/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <UnitAct/>
         </div>
         
         </div>
         </>
    )
}

export default PlanningActivityIndex
